import { createContext } from "react";
import { ConfirmOptions } from "./ConfirmProvider";

export const ConfirmContext = createContext<(options: ConfirmOptions) => Promise<() => void>>(() => {
  console.error("Missing ConfirmProvider");
  return Promise.resolve(() => {});
});
